<template>
    <v-card elevation="0" class="py-20px py-md-40px">
        <v-card-title class="tit tit--sm primary--text pt-0">
            <v-row justify="end" align="center">
                <v-col cols="auto">
                    대량 교환하기
                </v-col>
                <v-spacer />
                <v-col cols="auto">
                    <excel-sample v-slot="{ click }">
                        <v-btn large color="grey" class="my-n3" v-on="{ click }">
                            <span> 샘플 다운로드 </span>
                        </v-btn>
                    </excel-sample>
                </v-col>
                <v-col cols="auto">
                    <excel-upload v-bind="{ code }" v-slot="{ click }" v-on="{ emit }">
                        <v-btn large color="primary" class="my-n3" v-on="{ click }">
                            <span> 대량 업로드 </span>
                        </v-btn>
                    </excel-upload>
                </v-col>
            </v-row>
        </v-card-title>
        <v-card-text class="py-20px py-md-40px">
            <v-row justify="center">
                <v-col cols="12" sm="6" md="">
                    <v-row class="row--xx-small">
                        <v-col cols="auto"><v-img max-width="20" src="/images/icon/icon-1.svg"/></v-col>
                        <v-col>
                            <p class="page-text page-text--small line-height-13 min-h-lg-54px">위에 ‘샘플다운로드’ 버튼을 눌러 대량 업로드용 양식을 다운받습니다.</p>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" sm="6" md="">
                    <v-row class="row--xx-small">
                        <v-col cols="auto"><v-img max-width="20" src="/images/icon/icon-2.svg"/></v-col>
                        <v-col>
                            <p class="page-text page-text--small line-height-13 min-h-lg-54px">도서교환권이 있는 첫번째 줄은 수정하지 않고 두번째 줄부터 핀을 입력합니다.</p>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" sm="6" md="">
                    <v-row class="row--xx-small">
                        <v-col cols="auto"><v-img max-width="20" src="/images/icon/icon-3.svg"/></v-col>
                        <v-col>
                            <p class="page-text page-text--small line-height-13 min-h-lg-54px">파일을 저장 후 위에 ‘대량 업로드’ 버튼을 눌러 저장한 파일을 업로드합니다.</p>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" sm="6" md="">
                    <v-row class="row--xx-small">
                        <v-col cols="auto"><v-img max-width="20" src="/images/icon/icon-4.svg"/></v-col>
                        <v-col>
                            <p class="page-text page-text--small line-height-13 min-h-lg-54px">파일 업로드 후 ‘상품권 교환하기’ 버튼을 누르면 완료됩니다.</p>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import { USER_EXCHANGE_CODES } from "@/assets/lib";
import ExcelSample from "./excel/excel-sample.vue";
import ExcelUpload from "./excel/excel-upload.vue";

export default {
    components: {
        ExcelSample,
        ExcelUpload,
    },
    props: {
        value: { type: Array, default: () => [] },
        code: { type: String, default: USER_EXCHANGE_CODES.AUCTION.value.toLowerCase() },
    },
    methods: {
        emit(items) {
            this.$emit("input", items);
        },
    },
};
</script>

<style></style>
